import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { Box, Typography } from '@mui/material'

import { useCampaignsContext, CampaignsEditForm } from '../../../../features/campaigns'
import { CAMPAIGNS_COMBOS_IDS } from '../../constants'
import { useCombos } from '../../../../features/combos/hooks'
import { PageDisplayer } from '../../../../ui'

export const CampaignsDetailPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { campaignId } = useParams()
  useCombos(CAMPAIGNS_COMBOS_IDS)
  const { formatMessage } = useIntl()
  const { detailLoading, detailError, getCampaign, campaign } = useCampaignsContext()

  useEffect(() => {
    getCampaign(campaignId)
  }, [campaignId]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleGoBack = () => {
    const prevSearch = location.state?.prevSearch || ''
    navigate('/campaigns' + prevSearch)
  }

  return (
    <PageDisplayer
      maxWidth="md"
      loading={detailLoading}
      handleGoBack={handleGoBack}
      textGoBack={formatMessage({ id: 'pages.campaigns.detail.goBack' })}
    >
      {detailError ? (
        formatMessage({ id: 'pages.campaigns.detail.error' }, { campaignId })
      ) : (
        <>
          <Box mb={2}>
            <Typography variant="h4" color="textSecondary">
              {campaign['nombre'] || '{Nombre de la campaña}'}
            </Typography>
          </Box>
          <CampaignsEditForm />
        </>
      )}
    </PageDisplayer>
  )
}
